import React from "react"
import styled from "styled-components"

const Scollable = styled.div`
  overflow-x: scroll;
  margin: 0 -15px;
  padding: 15px;

  @media (min-width: 520px) {
    overflow-x: hidden;
    padding: 0 15px;
    max-width: 1115px;
    margin: 0 auto;
  }
`

const WrapperList = styled.div`
  display: flex;
  gap: 20px;

  @media (min-width: 520px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(144px, 1fr));
  }
`

const ProfilePicture = styled.div`
  margin: 10px 0px;

  @media (min-width: 768px) and (hover: hover) {
    opacity: 0.6;
    transition: opacity 0.3s;
  }

  * {
    width: 32vw;
    aspect-ratio: 1;
    object-fit: cover;
    object-position: top;
    border-radius: 50%;

    @media (min-width: 520px) {
      width: 144px;
      height: 144px;
    }
  }
`

const Profile = styled.div`
  display: flex;
  flex-direction: column;
  border: none;
  background: none;
  align-items: center;
  gap: 5px;
  color: var(--text-color);

  @media (min-width: 768px) and (hover: hover) {
    &:hover {
      ${ProfilePicture} {
        opacity: 1;
      }
    }
  }
`

const Name = styled.h6`
  font-weight: 700;
  font-size: 13px;
  margin: 0px;
  line-height: 134.8%;
  text-align: center;
  @media (min-width: 520px) {
    font-size: 15px;
  }
`
const Role = styled.p`
  font-weight: 400;
  font-size: 11px;
  line-height: 162.8%;
  text-align: center;
  @media (min-width: 520px) {
    font-size: 13px;
  }
`

const Employees = ({ contents }) => {
  return (
    <Scollable>
      <WrapperList>
        {contents.map((item, i) => (
          <Employee
            key={i}
            portrait={item.portrait}
            firstName={item.firstName}
            lastName={item.lastName}
            role={item.role}
          />
        ))}
      </WrapperList>
    </Scollable>
  )
}

const Employee = ({ firstName, lastName, role, portrait }) => {
  return (
    <Profile>
      <ProfilePicture>{portrait}</ProfilePicture>
      <Name>
        {firstName}&nbsp;{lastName}
      </Name>
      <Role>{role}</Role>
    </Profile>
  )
}

export { Employees }
